module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit-prompt"
  }, [(_vm.editPrompt) ? _c('div', {
    staticClass: "flex flex-column items-center h-100"
  }, [_c('div', {
    staticClass: "roundtable-title-div"
  }, [_c('div', {
    staticClass: "mr2"
  }, [_vm._v("Title:")]), _vm._v(" "), _c('pl-input', {
    staticStyle: {
      "flex-grow": "1"
    },
    model: {
      value: (_vm.roundtable_title),
      callback: function($$v) {
        _vm.roundtable_title = $$v
      },
      expression: "roundtable_title"
    }
  })], 1), _vm._v(" "), _c('build', {
    staticClass: "rt-create-modal",
    on: {
      "saveRoundtable": _vm.savePayload,
      "isSaving": function($event) {
        _vm.is_saving = true
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex self-end",
    staticStyle: {
      "height": "50px"
    }
  }, [_c('pl-button', {
    staticClass: "pl-small",
    staticStyle: {
      "color": "black",
      "font-size": "16px",
      "height": "30px",
      "margin-top": "20px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.openEdit.apply(null, arguments)
      }
    }
  }, [_vm._v("\n        Close\n      ")]), _vm._v(" "), _c('pl-button', {
    staticClass: "pl-small pl-primary",
    staticStyle: {
      "color": "#f0f0f0",
      "font-weight": "bold",
      "font-size": "16px",
      "height": "30px",
      "margin-top": "20px"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveRoundtable(_vm.payload_with_changes)
      }
    }
  }, [_vm._v("\n        Save and Close\n      ")])], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-a135dc56!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/pages/feed/promptInFeedModal.vue
// module id = 1372
// module chunks = 61